import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShieldCheckIcon, FileTextIcon, HelpCircleIcon, BookOpenIcon } from 'lucide-react';
type ModalContent = 'terms' | 'privacy' | 'faq' | 'about' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalContent>(null);
  const modalContents = {
    terms: {
      title: 'Términos y Condiciones',
      icon: FileTextIcon,
      content: <div className="space-y-4" data-id="element-8">
          <p className="text-gray-300" data-id="element-9">
            Al acceder al AI Web Closer System, aceptas los siguientes términos:
          </p>
          <div className="space-y-3" data-id="element-10">
            <div data-id="element-11">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-12">
                1. Uso del Sistema
              </h4>
              <p className="text-gray-400" data-id="element-13">
                El AI Web Closer System es una herramienta educativa diseñada
                para enseñarte a vender sitios web a negocios locales usando IA.
                El acceso al curso y las herramientas de IA está sujeto al pago
                de las tarifas correspondientes.
              </p>
            </div>
            <div data-id="element-14">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-15">
                2. Garantía de Resultados
              </h4>
              <p className="text-gray-400" data-id="element-16">
                Ofrecemos una garantía de 30 días. Si implementas el sistema,
                contactas al menos 5 negocios y no obtienes ningún interesado,
                te devolvemos tu dinero sin preguntas.
              </p>
            </div>
            <div data-id="element-17">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-18">
                3. Propiedad Intelectual
              </h4>
              <p className="text-gray-400" data-id="element-19">
                Todo el contenido del curso, incluyendo videos, guiones, y
                herramientas de IA, son propiedad exclusiva de AI Web Closer y
                están protegidos por derechos de autor.
              </p>
            </div>
            <div data-id="element-20">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-21">
                4. Responsabilidad
              </h4>
              <p className="text-gray-400" data-id="element-22">
                Los resultados pueden variar según tu esfuerzo y dedicación. No
                garantizamos ingresos específicos, pero proporcionamos las
                herramientas y el sistema probado para maximizar tus
                posibilidades de éxito.
              </p>
            </div>
          </div>
        </div>
    },
    privacy: {
      title: 'Política de Privacidad',
      icon: ShieldCheckIcon,
      content: <div className="space-y-4" data-id="element-23">
          <p className="text-gray-300" data-id="element-24">
            Tu privacidad es importante para nosotros. Esta política explica
            cómo manejamos tu información.
          </p>
          <div className="space-y-3" data-id="element-25">
            <div data-id="element-26">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-27">
                Información que Recopilamos
              </h4>
              <p className="text-gray-400" data-id="element-28">
                Recopilamos información básica necesaria para procesar tu compra
                y darte acceso al sistema: nombre, información de pago, y datos
                de uso del curso.
              </p>
            </div>
            <div data-id="element-29">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-30">
                Uso de Cookies
              </h4>
              <p className="text-gray-400" data-id="element-31">
                Utilizamos cookies para mejorar tu experiencia, recordar tus
                preferencias y rastrear el progreso del temporizador de oferta.
              </p>
            </div>
            <div data-id="element-32">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-33">
                Seguridad de Datos
              </h4>
              <p className="text-gray-400" data-id="element-34">
                Implementamos medidas de seguridad estándar de la industria para
                proteger tu información personal. Los pagos son procesados de
                forma segura a través de proveedores certificados.
              </p>
            </div>
            <div data-id="element-35">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-36">
                Compartir Información
              </h4>
              <p className="text-gray-400" data-id="element-37">
                No vendemos ni compartimos tu información personal con terceros,
                excepto cuando es necesario para procesar pagos o cumplir con
                requisitos legales.
              </p>
            </div>
          </div>
        </div>
    },
    faq: {
      title: 'Preguntas Frecuentes',
      icon: HelpCircleIcon,
      content: <div className="space-y-4" data-id="element-38">
          <div className="space-y-4" data-id="element-39">
            <div data-id="element-40">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-41">
                ¿Necesito experiencia previa?
              </h4>
              <p className="text-gray-400" data-id="element-42">
                No. El sistema está diseñado para principiantes. La IA hace el
                trabajo técnico, tú solo necesitas seguir el proceso de ventas.
              </p>
            </div>
            <div data-id="element-43">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-44">
                ¿Cuánto tiempo toma ver resultados?
              </h4>
              <p className="text-gray-400" data-id="element-45">
                Algunos miembros consiguen su primer cliente en la primera
                semana. El tiempo depende de tu dedicación y cuántos prospectos
                contactes.
              </p>
            </div>
            <div data-id="element-46">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-47">
                ¿Qué incluye el acceso al software de IA?
              </h4>
              <p className="text-gray-400" data-id="element-48">
                Incluye acceso a Local Scout (para encontrar prospectos) y Web
                Builder (para crear demos de sitios). Puedes elegir plan mensual
                ($40/mes) o anual ($20/mes facturado anualmente).
              </p>
            </div>
            <div data-id="element-49">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-50">
                ¿Funciona la garantía de 30 días?
              </h4>
              <p className="text-gray-400" data-id="element-51">
                Sí, 100%. Si implementas el sistema, contactas al menos 5
                negocios y no consigues ningún interesado, te devolvemos tu
                dinero sin preguntas.
              </p>
            </div>
            <div data-id="element-52">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-53">
                ¿Puedo cancelar mi suscripción de IA?
              </h4>
              <p className="text-gray-400" data-id="element-54">
                Sí, puedes cancelar en cualquier momento. El plan mensual no
                tiene compromiso. El plan anual se factura por adelantado pero
                ofrece mejor precio.
              </p>
            </div>
          </div>
        </div>
    },
    about: {
      title: 'Sobre AI Web Closer',
      icon: BookOpenIcon,
      content: <div className="space-y-4" data-id="element-55">
          <p className="text-gray-300" data-id="element-56">
            AI Web Closer System nació de una necesidad real: ayudar a personas
            sin experiencia técnica a ganar dinero ofreciendo servicios
            digitales.
          </p>
          <div className="space-y-3" data-id="element-57">
            <div data-id="element-58">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-59">
                Nuestra Misión
              </h4>
              <p className="text-gray-400" data-id="element-60">
                Democratizar el acceso a oportunidades de ingresos en servicios
                digitales, eliminando la barrera técnica con IA.
              </p>
            </div>
            <div data-id="element-61">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-62">
                El Problema que Resolvemos
              </h4>
              <p className="text-gray-400" data-id="element-63">
                Millones de negocios locales necesitan sitios web, pero la
                mayoría de personas creen que necesitan ser diseñadores o
                programadores para ayudarlos. Nuestra IA elimina esa barrera.
              </p>
            </div>
            <div data-id="element-64">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-65">
                Resultados Comprobados
              </h4>
              <p className="text-gray-400" data-id="element-66">
                Más de $50M generados por nuestros miembros. El sistema ha sido
                probado por miles de latinos que ahora ganan dinero vendiendo
                sitios web sin saber programar.
              </p>
            </div>
            <div data-id="element-67">
              <h4 className="font-heading font-bold text-lg text-gold mb-2" data-id="element-68">
                Nuestro Compromiso
              </h4>
              <p className="text-gray-400" data-id="element-69">
                Proporcionamos no solo el curso, sino un sistema completo:
                herramientas de IA, guiones probados, y soporte continuo para tu
                éxito.
              </p>
            </div>
          </div>
        </div>
    }
  };
  return <>
      <footer className="w-full bg-navy-dark border-t border-gold/20 py-12 px-4" data-id="element-70">
        <div className="max-w-7xl mx-auto" data-id="element-71">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-72">
            {/* Brand */}
            <div data-id="element-73">
              <h3 className="font-heading font-black text-2xl mb-4" data-id="element-74">
                <span className="text-gold" data-id="element-75">AI</span> Web Closer
              </h3>
              <p className="font-body text-sm text-gray-400 leading-relaxed" data-id="element-76">
                El sistema completo para ganar dinero vendiendo sitios web a
                negocios locales, sin saber diseño ni código.
              </p>
            </div>

            {/* Legal Links */}
            <div data-id="element-77">
              <h4 className="font-heading font-bold text-lg mb-4 text-white" data-id="element-78">
                Legal
              </h4>
              <ul className="space-y-2" data-id="element-79">
                <li data-id="element-80">
                  <button onClick={() => setActiveModal('terms')} className="font-body text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-81">
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-82">
                  <button onClick={() => setActiveModal('privacy')} className="font-body text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-83">
                    Política de Privacidad
                  </button>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div data-id="element-84">
              <h4 className="font-heading font-bold text-lg mb-4 text-white" data-id="element-85">
                Recursos
              </h4>
              <ul className="space-y-2" data-id="element-86">
                <li data-id="element-87">
                  <button onClick={() => setActiveModal('faq')} className="font-body text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-88">
                    Preguntas Frecuentes
                  </button>
                </li>
                <li data-id="element-89">
                  <button onClick={() => setActiveModal('about')} className="font-body text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-90">
                    Sobre Nosotros
                  </button>
                </li>
                <li data-id="element-91">
                  <a href="/login" className="font-body text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-92">
                    Área de Miembros
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gold/10 pt-8" data-id="element-93">
            <p className="font-body text-sm text-gray-500 text-center" data-id="element-94">
              © {new Date().getFullYear()} AI Web Closer. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-95">
        {activeModal && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100]" data-id="element-96" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="fixed inset-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-3xl md:max-h-[80vh] bg-gradient-to-br from-navy-dark to-navy border-2 border-gold/30 rounded-2xl shadow-2xl z-[101] overflow-hidden" data-id="element-97">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gold/20" data-id="element-98">
                <div className="flex items-center gap-3" data-id="element-99">
                  {(() => {
                const Icon = modalContents[activeModal].icon;
                return <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-100" />;
              })()}
                  <h3 className="font-heading font-bold text-2xl text-white" data-id="element-101">
                    {modalContents[activeModal].title}
                  </h3>
                </div>
                <button onClick={() => setActiveModal(null)} className="p-2 hover:bg-gold/10 rounded-lg transition-colors" aria-label="Cerrar" data-id="element-102">
                  <XIcon className="h-6 w-6 text-gray-400 hover:text-white" data-id="element-103" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-100px)]" data-id="element-104">
                {modalContents[activeModal].content}
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-gold/20 bg-navy-dark/50" data-id="element-105">
                <button onClick={() => setActiveModal(null)} className="w-full bg-gold hover:bg-gold-light text-navy font-heading font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-106">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}